<template>
  <v-app-bar color="green" dark app>
    <v-btn icon @click="$_voltar" title="Voltar ao formulário">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <v-toolbar-title>
      {{ titulo }}
    </v-toolbar-title>
  </v-app-bar>
</template>

<script>
import { ROUTE_MANUTENCAO_CADASTRO } from '@/constants/ROUTES';
import { MANUTENCAO_STORAGE } from '@/constants/STORAGE';

export default {
  name: 'TelaSelecaoAppBar',

  computed: {
    titulo() {
      const campo = this.$route.query.campo || sessionStorage.getItem(MANUTENCAO_STORAGE.campoSelecao) || '';
      const titulos = {
        frota: 'Selecionar Frota / Veículo',
        operador: 'Selecionar Operador',
        executor: 'Selecionar Executor',
        evento: 'Selecionar Evento',
        propriedade: 'Selecionar Propriedade',
        atividade: 'Selecionar Atividade',
        produto: 'Selecionar Peça / Item',
      };
      return titulos[campo] || 'Selecionar Item';
    },
  },

  methods: {
    $_voltar() {
      this.$router.replace({ name: ROUTE_MANUTENCAO_CADASTRO.name });
    },
  },
};
</script>
